import React, { useEffect } from "react"
import SignupLayout from ".";
import BackgroundImg from "../../assets/images/background/oogwai_wisdom.png";
import { BarLineChartIcon, SelectGoalsImg } from "../../components/Icons/iconImages";
import { Button } from "antd";
import { Controller, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Icons from '../../components/Icons';
import { useCreateTrialonboradingMutation } from "../../services/authSlice";
import ReactGA from "react-ga4";

const SelectGoals = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [createTrialOnboaring] = useCreateTrialonboradingMutation();

    const defaultValues = {
        excisitingTool: '',
    };
    const {
        getValues,
        handleSubmit,
        control,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues,
    });

    useEffect(() => {
        if (state?.selectGoals) {
            setValue('excisitingTool', state?.selectGoals);
        }
    }, [state])
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);

    const handleSignUp = async () => {
        setLoading(true);
        const payload = {
            "email": state?.email,
            "screen_1": {
                "company_name": state?.aboutCompany?.code,
                "industry": state?.aboutCompany?.industry,
                "your_role": state?.aboutCompany?.role,
                "company_site": state?.aboutCompany?.url,
                "website_url": state?.aboutCompany?.url
            },
            "screen_2": {
                "existing_analytics_ad_tools": state?.integration?.excisitingTool,
                "e_commerce_platform": state?.integration?.ecommerce_platform,
            },
            "screen_3": {
                "select_goals": getValues('excisitingTool')
            }
        }

        const final = {
            body: payload,
            header: state?.header
        }
        try {
            await createTrialOnboaring(final).unwrap()
                .then((res) => {
                    if (res) {
                        setLoading(false);
                        ReactGA.event('tool_integration_done', {
                            method: 'manual_selection',
                            user_type: 'new_user',
                        });
                        navigate('/setup-workspace', {
                            state: {
                                ...state,
                                selectGoals: getValues('excisitingTool')
                            }
                        });
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    setError(err?.data?.message || err?.error);
                })
        } catch (err: any) {
            setLoading(false);
            setError(err?.data?.message || err?.error);
        }


    }
    const handleSubmitError = (data: any) => {
        // console.log('error triggered', data)
    }

    return (
        <SignupLayout
            title={<p className="text-[#FFFFFF] font-bold text-6xl 2xl:text-7xl mt-3">You’re One Step Away from Smarter Decisions!</p>}
            description={<p className="text-[#FFFFFF] text-xl mt-3">Finish setting up and let AI reveal
                {' '}  <span className="relative border border-[#FDB022] text-[#F79009] font-semibold px-1.5 py-0.5 bg-[#325142] inline-block">
                    <span className="absolute h-[5px] w-[5px] top-[-3px] left-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] top-[-3px] right-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] bottom-[-3px] right-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] bottom-[-3px] left-[-3px] bg-[#FDB022]"></span>
                    hidden growth opportunities
                </span>{' '}
                across all your marketing channels.
            </p>}
            // background={BackgroundImg}
            icon={<SelectGoalsImg className="h-[80px] w-[80px] " />}
            percent={80}
            currentStep={5}
        >
            <div className="h-[calc(100vh-23.2rem)] max-w-[480px] mx-auto w-full">
                <div className=" text-center mt-8">
                    <div className="border border-gray-300 w-[56px] h-[56px] rounded-xl flex items-center justify-center m-auto shadow-sm">
                        <BarLineChartIcon className="w-[28px] h-auto text-[#414651]" />
                    </div>
                    <p className="text-[#181D27] font-semibold text-3xl mt-4">How would you use Oogwai’s wisdom?</p>
                    <p className="text-[#535862] text-md mt-2">Tell us what would you like to achieve with Oogwai</p>
                </div>
                <form onSubmit={handleSubmit(handleSignUp, handleSubmitError)} className="flex flex-col items-center justify-between mt-6 h-full gap-6">
                    <div className="max-w-[416px] w-full rounded-2xl flex flex-col space-y-4 md:space-y-4 h-full">
                        <div className="p-4 border border-[#E9EAEB] rounded-xl">
                            <p className="text-[#414651] font-semibold  text-base md:text-lg mb-4">Select Goals</p>
                            <Controller
                                control={control}
                                name="excisitingTool"
                                render={({ field: { onChange, value = [] } }: any) => {
                                    const toggleValue = (val: string) => {
                                        if (value.includes(val)) {
                                            onChange(value.filter((v: string) => v !== val));
                                        } else {
                                            onChange([...value, val]);
                                        }
                                    };

                                    return (
                                        <div className="flex flex-wrap items-center gap-2">
                                            {[
                                                { label: 'Appointment Booking', value: 'AppointmentBooking' },
                                                { label: 'Lead Generation', value: 'LeadGeneration' },
                                                { label: 'Online Sales', value: 'OnlineSales' },
                                                { label: 'Demo Bookings', value: 'DemoBookings' },
                                                { label: 'App Installs', value: 'AppInstalls' },
                                                { label: 'User Engagement', value: 'UserEngagement' },
                                                { label: 'Subscriptions', value: 'Subscriptions' },
                                                { label: 'Community Growth', value: 'CommunityGrowth' },
                                                { label: 'Brand Awareness', value: 'BrandAwareness' },
                                                { label: 'Other', value: 'Other' },
                                            ].map((tab, index) => (
                                                <span
                                                    key={index}
                                                    className={`cursor-pointer text-xs w-fit font-normal inline-flex items-center px-4 py-2 rounded-full  
              ${value.includes(tab.value)
                                                            ? "border border-[#B6F0D5] text-[#FFFFFF] bg-[#609F81] font-semibold"
                                                            : "border border-gray-400 text-[#414651] font-semibold bg-gray-100"
                                                        }`}
                                                    onClick={() => toggleValue(tab.value)}
                                                >
                                                    {tab.label}
                                                </span>
                                            ))}
                                        </div>
                                    );
                                }}
                            />


                        </div>

                        {error && (
                            <div className="flex items-center justify-between w-full border-t border-gray-200 dark:border-gray-600 pt-4">
                                <p className='text-red-500 text-sm'>{error}</p>
                                <Icons icon={"heroicons-outline:x-circle"} className="max-h-5 max-w-5 h-5 w-5 text-red-500 cursor-pointer" onClick={() => setError(null)} />
                            </div>
                        )}

                    </div>
                    <div className="flex items-center gap-6 w-full max-w-[416px]">
                        <p className="text-[#609F81] cursor-pointer font-semibold" onClick={() => navigate('/integration-pereference', {
                            state: {
                                ...state,
                                selectGoals: getValues('excisitingTool')
                            }
                        })}>Back</p>

                        <Button
                            type='primary'
                            className="w-full"
                            disabled={loading}
                            loading={loading}
                            // onClick={() => handleSignUp()}
                            htmlType="submit"

                        >
                            Continue
                        </Button>
                    </div>
                </form>
            </div>
        </SignupLayout>
    )
};

export default SelectGoals;
